<template>
  <WdsLabel sm subtle gray>
    {{ column.recruiterManagesWorkers ? $t('Managed') : $t('Referral fee') }}
  </WdsLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/composables/translation'

const CompanyRecruiterTypeColumn = graphql(`
  fragment CompanyRecruiterTypeColumn on CompanyRecruiter {
    recruiterManagesWorkers
  }
`)

const props = defineProps<{ row: FragmentType<typeof CompanyRecruiterTypeColumn> }>()
const column = computed(() => useFragment(CompanyRecruiterTypeColumn, props.row))
</script>
